import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noimage.png'
import _imports_1 from '@/assets/images/icn-move.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3db1488a")

_pushScopeId("data-v-3db1488a")
const _hoisted_1 = { class: "mylist-folder-list-item-image" }
const _hoisted_2 = {
  key: 1,
  class: "mylist-folder-list-item-image-noimage",
  src: _imports_0
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "mylist-folder-list-item-spacer" }, null, -1)
const _hoisted_4 = { class: "mylist-folder-list-item-title" }
const _hoisted_5 = { class: "mylist-folder-list-item-title-name" }
const _hoisted_6 = { class: "commonTextBodyDefault mylist-folder-list-item-title-name-text" }
const _hoisted_7 = { class: "mylist-folder-list-item-title-number" }
const _hoisted_8 = { class: "mylist-folder-list-item-title-number-number" }
const _hoisted_9 = { class: "commonTextCaption2 mylist-folder-list-item-title-number-number-text" }
const _hoisted_10 = { class: "mylist-folder-list-item-title-number-unit" }
const _hoisted_11 = { class: "commonTextCaption2 mylist-folder-list-item-title-number-unit-text" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "mylist-folder-list-item-spacer" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "mylist-folder-list-item-move-button handle" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "mylist-folder-list-item-move-button-image",
    src: _imports_1
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "mylist-folder-list-item",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.folderImageUrl)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            class: "mylist-folder-list-item-image-icon",
            src: _ctx.folderImageUrl
          }, null, 8, ["src"]))
        : (_openBlock(), _createBlock("img", _hoisted_2))
    ]),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.folderTitle), 1)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.folderNumString), 1)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.folderNumUnit), 1)
        ])
      ])
    ]),
    _hoisted_12,
    _hoisted_13
  ]))
})